import React, { useState, useEffect } from "react";
import axios from "axios";

const TableFour2 = props => {
  const API = props.API;
  const [FYSY, setFYSY] = useState([0, 0, 0]);
  const [GWB, setGWB] = useState([0, 0, 0]);
  const [FYSYW, setFYSYW] = useState([0, 0, 0]);
  const [GWBW, setGWBW] = useState([0, 0, 0]);
  const [editable, setEditable] = useState(false);
  const [editableW, setEditableW] = useState(false);

  const submitForm = data => {
    var settings = {
      url: API + "/sectionfourtwo-create",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        fysy: data.fysy,
        gwb: data.gwb,
        si: data.si,
        avgsi: data.avgsi
      }
    };

    axios(settings)
      .then(res => {
        console.log("Database Stored");
        console.log(res.data);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const submitFormTwo = data => {
    var settings = {
      url: API + "/sectionfourtwotwo-create",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        fysyw: data.fysyw,
        gwbw: data.gwbw,
        siw: data.siw,
        avgsiw: data.avgsiw
      }
    };

    axios(settings)
      .then(res => {
        console.log("Database Stored");
        console.log(res.data);
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    var settings = {
      url: API + "/sectionfourtwo-get",
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    };

    axios(settings)
      .then(res => {
        let fysy = res.data.fysy;
        let gwb = res.data.gwb;

        console.log("GET FROM 4 2");
        console.log(fysy);
        console.log(gwb);

        fysy.length === 0 ? setFYSY([0, 0, 0]) : setFYSY(fysy);
        gwb.length === 0 ? setGWB([0, 0, 0]) : setGWB(gwb);
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    var settings = {
      url: API + "/sectionfourtwotwo-get",
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    };

    axios(settings)
      .then(res => {
        let fysyw = res.data.fysyw;
        let gwbw = res.data.gwbw;

        console.log("GET FROM 4 2 2");
        console.log(fysyw);
        console.log(gwbw);

        fysyw.length === 0 ? setFYSYW([0, 0, 0]) : setFYSYW(fysyw);
        gwbw.length === 0 ? setGWBW([0, 0, 0]) : setGWBW(gwbw);
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  const changeData = (type, val, index, previousData) => {
    val = Number(val);

    switch (type) {
      case "FYSY":
        if (index === 0) setFYSY([val, previousData[1], previousData[2]]);
        if (index === 1) setFYSY([previousData[0], val, previousData[2]]);
        if (index === 2) setFYSY([previousData[0], previousData[1], val]);
        break;
      case "GWB":
        if (index === 0) setGWB([val, previousData[1], previousData[2]]);
        if (index === 1) setGWB([previousData[0], val, previousData[2]]);
        if (index === 2) setGWB([previousData[0], previousData[1], val]);
        break;
      case "FYSYW":
        if (index === 0) setFYSYW([val, previousData[1], previousData[2]]);
        if (index === 1) setFYSYW([previousData[0], val, previousData[2]]);
        if (index === 2) setFYSYW([previousData[0], previousData[1], val]);
        break;
      case "GWBW":
        if (index === 0) setGWBW([val, previousData[1], previousData[2]]);
        if (index === 1) setGWBW([previousData[0], val, previousData[2]]);
        if (index === 2) setGWBW([previousData[0], previousData[1], val]);
        break;
      default:
        console.log("Default");
    }
  };

  return (
    <div>
      <h2>4.2. Success Rate in the stipulated period of the program (40) </h2>
      <h3>
        4.2.1. Success rate without backlogs in any semester/year of study (25){" "}
      </h3>
      <p>
        <b>SI</b> = (Number of students who have graduated from the program
        without backlog)/ (Number of students admitted in the first year of that
        batch and admitted in 2nd year via lateral entry and separate division,
        if applicable) <br />
        <b>Average SI</b> = Mean of Success Index (SI) for past three batches{" "}
        <br />
        <b>Success rate without backlogs in any year of study</b> = 25 × Average
        SI
      </p>
      <table border="1" cellPadding="10" width="80%">
        <tbody>
          {/* Heading */}
          <tr>
            <th>Item</th>
            <th>
              Latest Year of Graduation, LYG <br />
              (CAYm4) (2013-2014)
            </th>
            <th>
              Latest Year of Graduation minus 1, <br /> LYGm1 (CAYm5)
              (2012-2013)
            </th>
            <th>
              Latest Year of Graduation minus 2, <br />
              LYGm2 (CAYm6) (2011-2012)
            </th>
          </tr>

          {/* FYSY */}
          <tr>
            <td>
              Number of students admitted in the corresponding First Year +
              admitted in 2nd year via lateral entry and separate division, if
              applicable
            </td>
            {FYSY.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("FYSY", e.target.value, index, [
                          FYSY[0],
                          FYSY[1],
                          FYSY[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* GWB */}
          <tr>
            <td>
              Number of students who have graduated without backlogs in the
              stipulated period
            </td>
            {GWB.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("GWB", e.target.value, index, [
                          GWB[0],
                          GWB[1],
                          GWB[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* SI */}
          <tr>
            <td>Success Index (SI)</td>
            <td>{Math.trunc(GWB[0] / FYSY[0]).toString()}</td>
            <td>{Math.trunc(GWB[1] / FYSY[1]).toString()}</td>
            <td>{Math.trunc(GWB[2] / FYSY[2]).toString()}</td>
          </tr>

          {/* AVGSI */}
          <tr>
            <td>Average SI</td>
            <td colSpan="3">
              {Math.trunc(
                (Math.trunc(GWB[0] / FYSY[0]) +
                  Math.trunc(GWB[1] / FYSY[1]) +
                  Math.trunc(GWB[2] / FYSY[2])) /
                  3
              ).toString()}
            </td>
          </tr>
        </tbody>
      </table>
      {editable ? null : (
        <button onClick={() => setEditable(true)}>Edit</button>
      )}
      &nbsp;
      <button
        onClick={() => {
          setEditable(false);

          var data = {
            fysy: FYSY,
            gwb: GWB,
            si: [
              Math.trunc(GWB[0] / FYSY[0]),
              Math.trunc(GWB[1] / FYSY[1]),
              Math.trunc(GWB[2] / FYSY[2])
            ],
            avgsi: [
              Math.trunc(
                (Math.trunc(GWB[0] / FYSY[0]) +
                  Math.trunc(GWB[1] / FYSY[1]) +
                  Math.trunc(GWB[2] / FYSY[2])) /
                  3
              )
            ]
          };
          console.log(data);

          submitForm(data);
        }}
      >
        Submit
      </button>
      <h3>
        4.2.2. Success rate with backlog in stipulated period of study (15)
      </h3>
      <p>
        <b>SI</b>= (Number of students who graduated from the program in the
        stipulated period of course duration)/ (Number of students admitted in
        the first year of that batch and admitted in 2nd year via lateral entry
        and separate division, if applicable) <br />
        <b>Average SI</b> = mean of Success Index (SI) for past three batches{" "}
        <br />
        <b>Success rate</b> = 15 × Average SI
      </p>
      <table border="1" cellPadding="10" width="80%">
        <tbody>
          {/* Heading */}
          <tr>
            <th>Item</th>
            <th>
              Latest Year of Graduation, LYG <br />
              (CAYm4) (2013-2014)
            </th>
            <th>
              Latest Year of Graduation minus 1, <br /> LYGm1 (CAYm5)
              (2012-2013)
            </th>
            <th>
              Latest Year of Graduation minus 2, <br />
              LYGm2 (CAYm6) (2011-2012)
            </th>
          </tr>

          {/* FYSYW */}
          <tr>
            <td>
              Number of students admitted in the corresponding First Year +
              admitted in 2nd year via lateral entry and separate division, if
              applicable
            </td>
            {FYSYW.map((d, index) => {
              if (editableW)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("FYSYW", e.target.value, index, [
                          FYSYW[0],
                          FYSYW[1],
                          FYSYW[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* GWBW */}
          <tr>
            <td>
              Number of students who have graduated with backlogs in the
              stipulated period
            </td>
            {GWBW.map((d, index) => {
              if (editableW)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("GWBW", e.target.value, index, [
                          GWBW[0],
                          GWBW[1],
                          GWBW[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* SIW */}
          <tr>
            <td>Success Index (SI)</td>
            <td>{Math.trunc(GWBW[0] / FYSYW[0]).toString()}</td>
            <td>{Math.trunc(GWBW[1] / FYSYW[1]).toString()}</td>
            <td>{Math.trunc(GWBW[2] / FYSYW[2]).toString()}</td>
          </tr>

          {/* AVGSIW */}
          <tr>
            <td>Average SI</td>
            <td colSpan="3">
              {Math.trunc(
                (Math.trunc(GWBW[0] / FYSYW[0]) +
                  Math.trunc(GWBW[1] / FYSYW[1]) +
                  Math.trunc(GWBW[2] / FYSYW[2])) /
                  3
              ).toString()}
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        <b>Note:</b> If 100% students clear without any backlog then also total
        marks scored will be 40 as both 4.2.1 & 4.2.2 will be applicable
        simultaneously.
      </p>
      {editableW ? null : (
        <button onClick={() => setEditableW(true)}>Edit</button>
      )}
      &nbsp;
      <button
        onClick={() => {
          setEditableW(false);

          var data = {
            fysyw: FYSYW,
            gwbw: GWBW,
            siw: [
              Math.trunc(GWBW[0] / FYSYW[0]),
              Math.trunc(GWBW[1] / FYSYW[1]),
              Math.trunc(GWBW[2] / FYSYW[2])
            ],
            avgsiw: [
              Math.trunc(
                (Math.trunc(GWBW[0] / FYSYW[0]) +
                  Math.trunc(GWBW[1] / FYSYW[1]) +
                  Math.trunc(GWBW[2] / FYSYW[2])) /
                  3
              )
            ]
          };
          console.log(data);
          submitFormTwo(data);
        }}
      >
        Submit
      </button>
    </div>
  );
};

export default TableFour2;
